import React from 'react';

import { Button } from 'antd-mobile';
import { useCountDown } from 'ahooks';
import cx from './index.module.scss';

interface Props {}

const ButtonWithCountdown: React.FC<Props> = () => {
  const [, formattedRes] = useCountDown({ leftTime: 10 * 1000 });

  return (
    <Button color="primary" disabled className={cx('btn')}>
      设备检测中
      {!!formattedRes?.seconds && <span>（{formattedRes.seconds}s）</span>}
    </Button>
  );
};

export default ButtonWithCountdown;
